// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './fonts/font.css'
import axios from 'axios'

router.afterEach((to,from,next)=>{
  window,scrollTo(0,0)
})

/**
 * 路由拦截器
 */
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    let isLogin = store.state.isLogin ? store.state.isLogin : window.sessionStorage.getItem("isLogin")
    console.log(isLogin)
    if (isLogin) {  // 判断是否登录了 store.state.isLogin
      next()
    } else {
      next({
        path: '/agentLogin',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(less)
Vue.use(ElementUI)
Vue.use(ViewUI)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js